const Translator = (transString, locale = 'fr-FR') => {
    // Add _ to support old locale syntax
    const [lang] = locale.split(/-|_/);
    const localeRegexp = new RegExp(`^(\\[${locale}\\])|(\\[${locale.replace('-', '_')}\\])`);
    const fallbackLang = new RegExp(`^(\\[${lang})|(\\[${lang.replace('-', '_')})`);
    const genericLanguage = /^\[[a-z]{2}(-|_)[A-Z]{2}\]/;

    // Get all languages from the string
    const languages = transString.split('|').map(e => e.trim());

    // Find by searching for locale
    let match = languages.find(language => localeRegexp.test(language));

    // Find by searching for language
    if (!match) {
        match = languages.find(language => fallbackLang.test(language));
    }

    // Get first
    if (!match) {
        match = languages[0];
    }

    return match.replace(genericLanguage, '');
};

export default Translator;
